export const getFileExtension = (str) => {
  return str.slice(str.lastIndexOf(".") + 1);
};
